import _uniqBy from 'lodash.uniqby'
import { setCookie } from '@/helpers'

export default {
	MENU_OPEN_CHANGE_STATE(state) {
		state.mainNaviIsOpen = !state.mainNaviIsOpen
	},
	SET_SERVICES_LOADED(state) {
		state.servicesLoaded = true
	},
	SET_MARKETS_LOADED(state) {
		state.marketsLoaded = true
	},
	SEARCH_MODAL_CHANGE_STATE(state) {
		state.searchModalOpen = !state.searchModalOpen
	},
	SEARCH_VALUE_CHANGE(state, payload) {
		state.searchValue = payload
	},
	SET_LOADED_TAXONOMIES(state) {
		state.taxonomiesLoaded = true
	},
	STORE_PAGE_DATA(state, payload) {
		if (payload && payload[0]) {
			payload.forEach((post) => {
				let postType = post.type ? post.type : 'undefined'
				if (!state.postsData[postType]) state.postsData = { ...state.postsData, ...{ [postType]: [] } }
				if (state.postsData[postType]) {
					// replace freshly laoded page if it is same as previous one, eg after enter password
					state.postsData[postType].filter((item, key) => {
						if (post.id === item.id) {
							state.postsData[postType][key] = post
						}
					})
				}
				state.postsData[postType].push(post)
				let filtered = _uniqBy(state.postsData[postType], 'id')
				//update meta ...
				if (filtered) state.postsData[postType] = filtered
			})
			//filtered = _orderby(filtered, 'date', 'desc');
		}
	},

	STORE_PAGE_MENU(state, payload) {
		if (payload && payload.items && payload.location) {
			state.menus[payload.location] = payload.items
		}
	},

	/**
	 *
	 * @param {Object} payload
	 * payload.set if we should set to dark mode
	 * payload.cookies if we should update user cookie
	 */
	DARK_MODE(state, payload) {
		const myBody = document.getElementsByTagName('body')[0]

		const addBodyClass = () => {
			this.isActive = true
			myBody.classList.add('dark-theme')
		}

		const removeBodyClass = () => {
			this.isActive = false
			myBody.classList.remove('dark-theme')
		}

		state.isDarkMode = payload.set
		if (payload.set === true) {
			addBodyClass()
			if (payload.cookies) setCookie('dark-theme', 'true', 365)
		} else {
			removeBodyClass()
			if (payload.cookies) setCookie('dark-theme', 'false', 365)
		}
	},
}
